import { Form } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';

interface PrelevementProps {
  compteBancairePreleve: string;
  titulaireComptePreleve: string;
  montant: number;
}

const Prelevement = (props: PrelevementProps) => {
  const {
    compteBancairePreleve: compteBancairePreleveProps,
    titulaireComptePreleve: titulaireComptePreleveProps,
    montant: montantProps,
  } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Prélèvement</label>
      </Form.Field>
      <Form.Field inline width={5}>
        Titulaire du compte
        {' : '}
        <label>{titulaireComptePreleveProps}</label>
      </Form.Field>
      <Form.Field inline width={7}>
        Compte bancaire prélevé
        {' : '}
        <label>{compteBancairePreleveProps}</label>
      </Form.Field>
      <Form.Field
        inline
        width={2}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default Prelevement;
